import { Link } from "react-router-dom";
import PageTitle from "../../Components/PageTitle";

const Dashboard = () => {
  const quickLinks = [
    { path: "/Masters/ManageProducts", label: "Manage Products", icon: "ri-list-settings-line", color: "secondary" },
    { path: "/Masters/ProductList", label: "Product List", icon: "ri-product-hunt-line", color: "info" },
    { path: "/Masters/ManageCategory", label: "Categories", icon: "ri-folder-line", color: "success" },
    { path: "/Masters/ManageProductCategories", label: "Product Categories", icon: "ri-price-tag-3-line", color: "danger" },
    { path: "/Masters/ManageHeroSlider", label: "Hero Sliders", icon: "ri-image-line", color: "warning" },
    { path: "/Masters/InquiryEmails", label: "Inquiry Emails", icon: "ri-mail-line", color: "danger" },
    { path: "/Masters/ManageUser", label: "Users", icon: "ri-user-line", color: "primary" },
  ];

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row mb-3">
              <PageTitle title="Dashboard" primary="Dashboard" />
            </div>

            {/* Quick Access Cards */}
            <div className="row g-4">
              {quickLinks.map((link) => (
                <div className="col-xl-3 col-md-6 col-sm-6" key={link.path}>
                  <Link to={link.path} className="text-decoration-none">
                    <div className={`card h-100 shadow-sm border-0 transition-hover`}>
                      <div className="card-body text-center">
                        <div className={`avatar-sm mx-auto mb-3 bg-${link.color}-subtle rounded-circle d-flex align-items-center justify-content-center`}>
                          <i className={`${link.icon} fs-1 text-${link.color}`}></i>
                        </div>
                        <h5 className="card-title text-dark">{link.label}</h5>
                        <p className="card-text text-muted small">
                          Manage {link.label.toLowerCase()}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      {/* Inline styles for hover effect (you can move to a CSS file if preferred) */}
      <style jsx>{`
        .transition-hover {
          transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }
        .transition-hover:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15) !important;
        }
      `}</style>
    </>
  );
};

export default Dashboard;